import React from 'react';
import Modal from 'react-bootstrap/lib/Modal';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import withI18next from '~/../hocs/_withI18next';
import FontIcomoonIcon from '~/components/FontIcomoonIcon';
import Config from '~/config';
import { makeSelectIsAuthenticated } from '~/containers/AuthProvider/selectors';
import { makeSelectCurrentLang } from '~/containers/MetadataProvider/selectors';

@withI18next()
class GiftListComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      listGift: [
        {
          name: this.props.t('credit_premium_gift_image_title1'),
          path: `${Config.staticPrefix}/static/assets/image/premium/gift/01.png`,
          thumbnail: `${Config.staticPrefix}/static/assets/image/premium/gift/thumbnail01.jpg`,
        },
        {
          name: this.props.t('credit_premium_gift_image_title2'),
          path: `${Config.staticPrefix}/static/assets/image/premium/gift/02.png`,
          thumbnail: `${Config.staticPrefix}/static/assets/image/premium/gift/thumbnail02.jpg`,
        },
        {
          name: this.props.t('credit_premium_gift_image_title3'),
          path: `${Config.staticPrefix}/static/assets/image/premium/gift/03.png`,
          thumbnail: `${Config.staticPrefix}/static/assets/image/premium/gift/thumbnail03.jpg`,
        },
        {
          name: this.props.t('credit_premium_gift_image_title4'),
          path: `${Config.staticPrefix}/static/assets/image/premium/gift/04.png`,
          thumbnail: `${Config.staticPrefix}/static/assets/image/premium/gift/thumbnail04.jpg`,
        },
        {
          name: this.props.t('credit_premium_gift_image_title5'),
          path: `${Config.staticPrefix}/static/assets/image/premium/gift/05.png`,
          thumbnail: `${Config.staticPrefix}/static/assets/image/premium/gift/thumbnail05.jpg`,
        },
        {
          name: this.props.t('credit_premium_gift_image_title6'),
          path: `${Config.staticPrefix}/static/assets/image/premium/gift/06.png`,
          thumbnail: `${Config.staticPrefix}/static/assets/image/premium/gift/thumbnail06.jpg`,
        },
        {
          name: this.props.t('credit_premium_gift_image_title7'),
          path: `${Config.staticPrefix}/static/assets/image/premium/gift/07.png`,
          thumbnail: `${Config.staticPrefix}/static/assets/image/premium/gift/thumbnail07.jpg`,
        },
        {
          name: this.props.t('credit_premium_gift_image_title8'),
          path: `${Config.staticPrefix}/static/assets/image/premium/gift/08.png`,
          thumbnail: `${Config.staticPrefix}/static/assets/image/premium/gift/thumbnail08.jpg`,
        },
      ],
      showModal: false,
      thumbnail: '',
    };
  }

  onShowModal(thumbnail) {
    this.setState({ showModal: true, thumbnail });
  }

  onCloseModal() {
    this.setState({ showModal: false, thumbnail: '' });
  }

  render() {
    const { isAuthenticated, currentLang, t, profile } = this.props;
    return (
      <div className="gift-list">
        <div className="container pt50 pb50">
          <div className="pb10">
            <h1 className={`text-center color-${Config.serviceType}`}>
              {this.props.t('credit_premium_gift_title1')}
            </h1>
            <h1 className={`text-center color-${Config.serviceType}`}>
              {this.props.t('credit_premium_gift_title2')}
            </h1>
          </div>
          <p className="pt10 premium-gift-description">
            {t('credit_premium_gift_content')}
          </p>
          <div className="gift-images">
            {this.state.listGift.map((item, index) => (
              <div key={index} className="item-gift-image">
                <div style={{ position: 'relative', margin: '10px 25px' }}>
                  <img
                    style={{ display: 'inline-block', width: '100%' }}
                    className="img-responsive"
                    src={item.path}
                    alt={item.name}
                  />
                  <div
                    className="gift-image"
                    onClick={this.onShowModal.bind(this, item.thumbnail)}
                  >
                    <FontIcomoonIcon icon="icon-search-premium" />
                  </div>
                </div>
                <div className="pt10">{item.name}</div>
              </div>
            ))}
          </div>
          {profile.role != Config.getRoles().PREMIUM && (
            <div className="text-center pt50">
              {/* {isAuthenticated ? ( */}
              <button
                onClick={this.props.onRegisterPremium}
                className={`btn btn-ac-primary btn-${Config.serviceType} btn-join-premium`}
              >
                <div
                  style={{ marginTop: 5 }}
                  dangerouslySetInnerHTML={{
                    __html: t('credit_premium_benefit_button3', { prices: '' }),
                  }}
                />
                {/* <FontIcomoonIcon icon={'icon-right-arrow'} style={{paddingLeft: 5}}/> */}
              </button>
              {/* ) : (
              <Link href="/login?redirect=register-premium" language={currentLang}>
                <a className={`btn button-shadow-lg button-shadow button-${Config.serviceType}  ${Config.getPrefixContent('btn-ac-primary')}`}>
                  <div style={{ marginTop: 5 }} dangerouslySetInnerHTML={{ __html: t('credit_premium_benefit_button3', { prices: priceMonthly }) }} />

                </a>
              </Link>
            )} */}
            </div>
          )}
          <Modal
            show={this.state.showModal}
            onHide={this.onCloseModal.bind(this)}
          >
            <Modal.Body>
              <img
                src={this.state.thumbnail}
                className="img-responsive"
                alt="img responsive"
              />
            </Modal.Body>
          </Modal>
        </div>
        <style jsx global>
          {`
            .gift-list .btn-join-premium {
              height: 60px;
              padding-left: 35px;
              padding-right: 35px;
              text-transform: uppercase;
            }

            .gift-list .premium-gift-description {
              font-size: 15px;
            }

            .gift-list .button-design_ac {
              background: #ffa823;
              box-shadow: 0 5px 1px -1px #774d17;
            }

            .gift-list .gift-images {
              display: grid;
              grid-template-columns: 25% 25% 25% 25%;
            }

            .gift-list .gift-images-3 {
              display: grid;
              grid-template-columns:
                calc(100% / 3) calc(100% / 3) calc(100% / 3)
                calc(100% / 3);
            }

            .gift-list .item-gift-image {
              padding: 15px 10px;
              text-align: center;
            }

            .gift-list .gift-image {
              width: 100%;
              height: 100%;
              position: absolute;
              top: 0;
              border-radius: 50%;
              cursor: pointer;
              display: flex;
              justify-content: center;
              align-items: center;
              font-size: 45px;
            }
            .gift-list .gift-image .icon-search-premium {
              display: none;
            }
            .gift-list .gift-image:hover {
              background-color: rgba(0, 0, 0, 0.5);
            }
            .gift-list .gift-image:hover .icon-search-premium {
              display: inline;
            }

            @media (max-width: 767px) {
              .gift-list .gift-images {
                grid-template-columns: 50% 50%;
              }
              .gift-list .gift-images-3 {
                grid-template-columns: 50% 50%;
              }
            }
          `}
        </style>
      </div>
    );
  }
}

const mapStateToProps = createStructuredSelector({
  isAuthenticated: makeSelectIsAuthenticated(),
  currentLang: makeSelectCurrentLang(),
});
export default connect(mapStateToProps)(GiftListComponent);
